/**
 * AI & Intelligence Icons
 * 
 * Icons for AI features, automation, smart suggestions, and machine learning.
 * 
 * Used by: AI chat, smart features, automation, knowledge coverage
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBrain as fadBrain,
  faBrainCircuit as fadBrainCircuit,
  faBrainArrowCurvedRight as fadBrainArrowCurvedRight,
  faRobot as fadRobot,
  faWandMagicSparkles as fadWandMagicSparkles,
  faMagic as fadMagic,
  faLightbulb as fadLightbulb,
  faLightbulbOn as fadLightbulbOn,
  faSparkles as fadSparkles,
  faMagnifyingGlassChart as fadMagnifyingGlassChart,
  faGaugeHigh as fadGaugeHigh,
  faBullseyeArrow as fadBullseyeArrow,
  faChartLine as fadChartLine,
  faChartLineUp as fadChartLineUp,
  faChartBar as fadChartBar,
  faChartPie as fadChartPie,
  faChartMixed as fadChartMixed,
  faChartSimple as fadChartSimple,
  faChartGantt as fadChartGantt,
  faChartColumn as fadChartColumn,
  faChartPieSimple as fadChartPieSimple,
  faTimeline as fadTimeline,
  faGaugeHigh as fadGaugeHigh2,
  faDiagramProject as fadDiagramProject,
  faObjectGroup as fadObjectGroup,
  faInfinity as fadInfinity,
  faBolt as fadBolt,
  faRocket as fadRocket,
  faStars as fadStars,
  faStarShooting as fadStarShooting,
  faStar as fadStar,
  faPaperPlane as fadPaperPlane,
  faChartNetwork as fadChartNetwork,
  faMicrochip as fadMicrochip,
} from "@fortawesome/pro-duotone-svg-icons";

export const loadAIIcons = () => {
  library.add(
    fadBrain,
    fadBrainCircuit,
    fadBrainArrowCurvedRight,
    fadRobot,
    fadWandMagicSparkles,
    fadMagic,
    fadLightbulb,
    fadLightbulbOn,
    fadSparkles,
    fadMagnifyingGlassChart,
    fadGaugeHigh,
    fadBullseyeArrow,
    fadChartLine,
    fadChartLineUp,
    fadChartBar,
    fadChartPie,
    fadChartMixed,
    fadChartSimple,
    fadChartGantt,
    fadChartColumn,
    fadChartPieSimple,
    fadTimeline,
    fadGaugeHigh2,
    fadDiagramProject,
    fadObjectGroup,
    fadInfinity,
    fadBolt,
    fadRocket,
    fadStars,
    fadStarShooting,
    fadStar,
    fadPaperPlane,
    fadChartNetwork,
    fadMicrochip
  );
};
